module.exports = __webpack_public_path__ + "media/images/svg/creations-e816d14c151bdcc38e5fb19d6f8ef8e5.svg";